import { useQuery } from "@apollo/client";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { User } from "../../graphql/baseTypes";
import { LIST_ALL_USERS } from "../../graphql/queries";
import { ListAllUsersQuery } from "../../graphql/queries/listUsers";
import { FilterProps } from "./types";

interface Props extends FilterProps<User> {
  value?: string | null;
}

const UserFilter: React.FC<Props> = ({ onChange, onClear, value }) => {
  const { data, loading } = useQuery<ListAllUsersQuery>(LIST_ALL_USERS, {
    onError(error) {
      console.log(error);
    },
  });
  const { listUsers } = data || { listCompanys: { items: [] } };
  const { items } = listUsers || {};

  const selected =
    React.useMemo(() => items?.find(({ username }) => value === username), [
      items,
      value,
    ]) || null;
  return (
    <Autocomplete<User>
      id="user-filter-autocomplete"
      options={items || []}
      loading={loading}
      value={selected}
      getOptionLabel={(option) => option.username}
      onChange={(_, selection) => {
        if (selection) {
          onChange(selection.username);
        } else {
          onClear();
        }
      }}
      getOptionSelected={(option, value) =>
        value && value.username ? option.username === value.username : false
      }
      style={{ width: 200 }}
      noOptionsText={"Keine Benutzer gefunden"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Benutzer"
          variant="outlined"
          size={"small"}
        />
      )}
    />
  );
};

export default UserFilter;
